import React from "react";
import { siteData } from "../data/mockData";

const DoctorsSection = () => {
  const { doctors } = siteData;

  return (
    <section className="w-full bg-white py-16 md:py-24 px-6 md:px-16">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-16">
          <div>
            <h2 className="font-poppins font-bold text-[1.8rem] md:text-[2.2rem] text-[#1a1a1a] leading-tight">
              Meet Some of Our
            </h2>
            <div className="flex items-end gap-0 mt-1">
              <h2 className="font-poppins font-bold text-[1.8rem] md:text-[2.2rem] text-[#D1D776] leading-tight italic whitespace-nowrap">
                Brains
              </h2>
              <div className="flex-1 h-[3px] bg-[#D1D776] ml-6 mb-2 min-w-[200px] md:min-w-[400px]" />
            </div>
          </div>
          <div className="mt-4 md:mt-0">
            <h3 className="font-poppins font-bold text-[1.8rem] md:text-[2.2rem] text-[#1a1a1a] whitespace-nowrap italic">
              Meet our Doctors
            </h3>
          </div>
        </div>

        {/* Doctors Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          {doctors.map((doctor, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-[200px] h-[200px] rounded-full overflow-hidden bg-gray-100 mb-5 group-hover:shadow-lg transition-shadow">
                <img
                  src={doctor.image}
                  alt={doctor.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h4 className="font-poppins font-semibold text-[#1a1a1a] text-base mb-0.5">
                {doctor.name}
              </h4>
              <p className="font-poppins text-[#1CA0B9] font-medium text-sm mb-1">
                {doctor.role}
              </p>
              {doctor.specialties && doctor.specialties.length > 0 && (
                <div className="flex flex-wrap justify-center gap-1.5 mt-1.5">
                  {doctor.specialties.map((spec, i) => (
                    <span
                      key={i}
                      className="font-poppins text-[11px] text-[#555] bg-[#F0F0F0] px-2.5 py-0.5 rounded-full"
                    >
                      {spec}
                    </span>
                  ))}
                </div>
              )}
              <p className="font-poppins text-[#999] text-xs mt-2">
                {doctor.location}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DoctorsSection;
